export const formatCurrency = (v, currency = "USD") => {
  if (v === null || v === undefined || Number.isNaN(v)) return "-";
  try {
    return new Intl.NumberFormat(undefined, { style: "currency", currency, maximumFractionDigits: 2 }).format(v);
  } catch {
    return `$${Number(v).toLocaleString()}`;
  }
};

export const formatChange = (v) => (v === null || v === undefined ? "-" : `${Number(v).toFixed(2)}%`);

export const pctColor = (pct) => {
  if (pct > 0) return "success.main";
  if (pct < 0) return "error.main";
  return "text.secondary";
};
